export default __webpack_public_path__ + "static/2-15b4f9bc0866a3cde5c5de169093e921.png";